import React, { Component } from "react";
import { withRouter, Switch, Route } from "react-router-dom";
import { withCookies } from "react-cookie";
import { connect } from "react-redux";

import {
	loadVisitorNew,
	newVisitor,
	getIpInfo,
	setUserInfo
} from "./actions/DataCol/userdataAction";
// import Header from "./components/Header/Header";
import HomePage from "./components/pages/HomePage/HomePage";
import Map from "./components/pages/Map/Map";
import Neighbourhood from "./components/pages/Neighbourhood/Neighbourhood";
import NeighbourhoodTemplate from "./components/pages/Neighbourhood/NeighbourhoodTemplate";
import Calculator from "./components/pages/Calculator/Calculator";
import Survey from "./components/pages/Survey/Survey";
import CareersPage from "./components/pages/Careers/CareersPage";
import Analytics from "./components/pages/Analytics/Analytics";
import AdminPage from "./components/pages/Admin/AdminPage";
import ApproveEmployer from "./components/pages/Admin/ApproveEmployer";
import SignIn from "./components/pages/Admin/SignIn";
import ErrorPage from "./components/pages/ErrorPage/ErrorPage";
import PrivateRoute from "./components/auth/PrivateRoute";
import PrivateRouteTalent from "./components/auth/PrivateRouteTalent";
import Chat from "./components/chat/Chat";
import KingstonConnect from "./components/pages/KingstonConnect/KingstonConnect";
import KingstonHome from "./components/pages/KingstonConnect/HomePage";

import InviteTalent from "./components/pages/KingstonConnect/InviteTalent";
import NoSignInInvite from "./components/pages/KingstonConnect/NoSignInInvite";
import AcceptTalent from "./components/pages/KingstonConnect/AcceptTalent";
import AcceptEmployer from "./components/pages/KingstonConnect/AcceptEmployer";
import ViewTalent from "./components/pages/KingstonConnect/ViewTalent";
import ViewMyInvites from "./components/pages/KingstonConnect/ViewMyInvites";
import ManageProfile from "./components/pages/KingstonConnect/ManageProfile";
import ThanksPage from "./components/pages/KingstonConnect/ThanksPage";
import uuidv1 from "uuid/v1";

class App extends Component {
	constructor(props) {
		super(props);
		this.state = {
			data_read_in: false,
			user: undefined
		};
	}
	componentDidMount() {
		this.cookies();
	}

	cookies = () => {
		const { cookies } = this.props;
		var userId = cookies.get("userID");

		if (userId === undefined) {
			userId = uuidv1();
			cookies.set("userID", userId, { path: "/", maxAge: 15552000 });
			getIpInfo().then(result => {
				var user = {};
				user["location"] = result.data;
				user["userId"] = userId;
				var date = new Date();

				let month = undefined;
				let init_month = date.getMonth() + 1;
				if (init_month < 10) {
					month = `0${init_month}`;
				} else {
					month = init_month.toString();
				}

				user[
					"date_visited"
				] = `${date.getFullYear()}-${month}-${date.getDate()} ${date.getHours()}:${date.getMinutes()}:${date.getSeconds()}`;

				newVisitor(user).then(res => {
					this.setState(
						{
							user: res.data
						},
						() => {
							this.props.setUserInfo(this.state.user);
						}
					);
				});
			});
		} else {
			// loadVisitor(userId).then(res => {
			loadVisitorNew(userId, this.props.history.location.pathname).then(res => {
				if (res.data === null) {
					userId = uuidv1();
					cookies.set("userID", userId, {
						path: "/",
						maxAge: 15552000
					});
					getIpInfo().then(result => {
						var user = {};
						user["location"] = result.data;
						user["userId"] = userId;
						var date = new Date();
						let month = undefined;
						let init_month = date.getMonth() + 1;
						if (init_month < 10) {
							month = `0${init_month}`;
						} else {
							month = init_month.toString();
						}
						user[
							"date_visited"
						] = `${date.getFullYear()}-${month}-${date.getDate()} ${date.getHours()}:${date.getMinutes()}:${date.getSeconds()}`;

						newVisitor(user).then(res => {
							this.setState(
								{
									user: res.data
								},
								() => {
									this.props.setUserInfo(this.state.user);
								}
							);
						});
					});
				} else {
					this.setState(
						{
							user: res.data
						},
						() => {
							this.props.setUserInfo(this.state.user);
						}
					);
				}
			});
		}
	};

	render() {
		return (
			<div id="app-wrapper">
				{/*<Header />*/}
				<Switch>
					<Route
						exact
						path="/"
						render={() => <HomePage cookies={this.props.cookies} />}
					/>
					<Route exact path="/map" component={Map} />
					<Route exact path="/careers" component={CareersPage} />
					<Route
						exact
						path="/neighbourhoods"
						component={Neighbourhood}
					/>
					<Route
						exact
						path="/neighbourhood_template"
						component={NeighbourhoodTemplate}
					/>
					<Route exact path="/calculator" component={Calculator} />
					<Route exact path="/survey" component={Survey} />
					<PrivateRoute exact path="/analytics" component={Analytics} />
					<Route
						exact
						path="/kingstonconnect"
						component={KingstonConnect}
					/>
					<Route
						exact
						path="/chat"
						component={Chat}
					/>
					<Route exact path="/kingstonhome" component={KingstonHome} />
					<Route
						path="/kingstonconnect/accept"
						component={AcceptTalent}
					/>
					<Route
						path="/kingstonhome/invite"
						component={NoSignInInvite}
					/>
					<Route
						path="/kingstonconnect/thankyou"
						component={ThanksPage}
					/>
					<PrivateRouteTalent
						path="/kingstonconnect/invite"
						component={InviteTalent}
					/>
					<PrivateRouteTalent
						path="/kingstonconnect/view"
						component={ViewTalent}
					/>
					<PrivateRouteTalent
						path="/kingstonconnect/myinvites"
						component={ViewMyInvites}
					/>
					<PrivateRouteTalent
						path="/kingstonconnect/manage"
						component={ManageProfile}
					/>
					<Route path="/signin" component={SignIn} />
					<Route
						path="/kingstonconnect/employer/accept"
						component={AcceptEmployer}
					/>
					<PrivateRoute exact path="/admin" component={AdminPage} />
					<PrivateRoute
						path="/admin/accept"
						component={ApproveEmployer}
					/>
					<Route component={ErrorPage} />
				</Switch>
				{/*<Chat />*/}
			</div>
		);
	}
}

const actions = {
	setUserInfo
};

const mapStateToProps = (state, ownProps) => {
	return {
		state: state,
		cookies: ownProps.cookies,
		user: state.user.user
	};
};

export default withCookies(
	withRouter(
		connect(
			mapStateToProps,
			actions
		)(App)
	)
);



// WEBPACK FOOTER //
// ./src/App.js